<template>
  <div class="universities">
    <div class="banner">
      <img
        width="100%"
        :src="headerBannerSrc"
        alt=""
      >
    </div>
    <div class="content">
      <div class="universities-content">
        <h2 class="universities-tit">高校合作项目:</h2>
        <ul class="universities-list">
          <li v-for="(item, index) in universitiesList" :key="index">
            <div class="universities-left">
              <img width="100%" :src="item.banner">
            </div>
            <div class="universities-right">
              <p class="universities-right-tit">
                <img :src="item.icon" alt="">
                <span>{{ item.name }}</span>
              </p>

              <p class="universities-right-tip">合作课程:</p>
              <p class="universities-right-con">{{ item.con }}</p>
              <p class="universities-right-con">
                课程时间: <span>{{ item.time }}</span>
              </p>

              <p class="universities-right-option">
                <a href="javascript:" @click="handleClickProduction">作品展示</a>
                <a href="javascript:" @click="handleClickDeveloper">开发者展示</a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { os } from '@/utils/index'

const { isPc } = os()
const assetBasicCatalog = isPc ? 'pc' : 'mobile'
const basicSrc = `assets/images/universities/${assetBasicCatalog}`

export default {
  name: 'universities',
  // 引入的组件
  components: {},
  // 混入
  // 当前页面的数据定义
  data() {
    return {
      headerBannerSrc: require(`@/${basicSrc}/head-banner.jpg`),
      universitiesList: [
        {
          banner: require(`@/${basicSrc}/banner-1.jpg`),
          icon: require(`@/${basicSrc}/icon-1.png`),
          name: '电子科技大学',
          con: '罗布乐思与电子科技大学联合开设《Roblox游戏设计与开发》课程',
          time: '2020年3月-5月'
        },
        {
          banner: require(`@/${basicSrc}/banner-2.jpg`),
          icon: require(`@/${basicSrc}/icon-2.png`),
          name: '华中科技大学',
          con: '罗布乐思与华中科技大学联合开设《游戏学导论》实践课程',
          time: '2020年5月-6月'
        },
        {
          banner: require(`@/${basicSrc}/banner-3.jpg`),
          icon: require(`@/${basicSrc}/icon-3.png`),
          name: '北京大学',
          con: '罗布乐思与北京大学联合开设《游戏化创新思维》课程',
          time: '2020年6月-7月'
        },
        {
          banner: require(`@/${basicSrc}/banner-4.jpg`),
          icon: require(`@/${basicSrc}/icon-4.png`),
          name: '上海交通大学',
          con: '罗布乐思与上海交通大学联合开设《腾讯游戏程序开发以及经典案例分析》课程',
          time: '2020年10月-12月'
        }
      ]
    }
  },
  // 计算属性
  computed: {},
  // 页面初始化的时候执行的方法
  created() {},
  // html已经渲染并挂载后的执行方法
  mounted() {},
  // 当前页面的方法集合
  methods: {
    handleClickProduction() {
      this.$router.push({
        path: `/experiences`
      })
    },
    handleClickDeveloper() {
      this.$router.push({
        path: `/developers`
      })
    }
  }
}
</script>

<style lang="scss" scope>
.universities {
  .universities-tit {
    padding-top: 100PX;
    padding-bottom: 65PX;
    font-size: 24PX;
    line-height: 100%;
    color: #fff;
  }
  .universities-content {
    text-align: left;
    margin: 0 auto;
    width: 1200PX;
    color: #fff;
    box-sizing: border-box;
  }
  .universities-list {
    li {
      margin-bottom: 108PX;
      padding: 35PX 42PX;
      height: 320PX;
      background-color: #0d0d0d;

      .universities-left {
        float: left;
        width: 410PX;
        height: 100%;
      }
      .universities-right {
        margin-left: 520PX;
        height: 100%;
        font-size: 14PX;
        line-height: 100%;

        &-tit {
          height: 86PX;
          line-height: 86PX;
          font-size: 20PX;

          span {
            margin-left: 28PX;
          }
        }

        &-tip {
          margin-top: 28PX;
        }

        &-con {
          margin-top: 20PX;
          color: #bdbdbd;
        }

        &-option {
          margin-top: 20PX;

          a {
            margin-right: 20PX;
            display: inline-block;
            vertical-align: middle;
            padding-bottom: 5PX;
            border-bottom: 1px solid  #fff;
            color: #fff;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .universities {
    .universities-tit {
      padding-top: 100px;
      padding-bottom: 94px;
      font-size: 40px;
    }

    .universities-content {
      width: 100%;
      padding: 0 30px;
    }

    .universities-list {
      li {
        margin-bottom: 100px;
        padding: 34px;
        padding-top: 0;
        height: 100%;

        .universities-left {
          width: 100%;
          height: 240px;
          float: inherit;
        }
        .universities-right {
          margin-left: 0;
          height: auto;
          font-size: 14PX;
          line-height: 100%;

          &-tit {
            margin-top: 30px;
            height: 82px;
            line-height: 82px;
            font-size: 30px;

            img {
              width: 82px;
              height: 82px;
            }

            span {
              margin-left: 20px;
            }
          }

          &-tip {
            margin-top: 35px;
          }

          &-con {
            margin-top: 20px;
            line-height: 40px;
          }

          &-option {
            margin-top: 45px;

            a {
              margin-right: 20px;
              padding-bottom: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
